import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import { getSingnature, decodeHtml } from "../helper/settingsHelper.js";
import { getGeneralSettings } from '../helper/settingsHelper.js';

const editorConstant = {
  toolBar: [
    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
    [{ 'size': [] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
  ],
  format: [
    'header', 'font', 'size',
    'bold', 'italic', 'underline',
    'list', 'bullet', 'indent'
  ]
}

// Simple function to convert ReactQuill classes to inline styles
const convertToInlineStyles = (html) => {
  if (!html) return "";
  return html
    .replace(/class="ql-bold"/g, 'style="font-weight:bold"')
    .replace(/class="ql-italic"/g, 'style="font-style:italic"')
    .replace(/class="ql-underline"/g, 'style="text-decoration:underline"')
    .replace(/class="ql-size-(small|large|huge)"/g, (match, size) => {
      const sizeMap = { small: '0.75em', large: '1.5em', huge: '2.5em' };
      return `style="font-size:${sizeMap[size]}"`;
    })
    .replace(/class="ql-align-(center|right|justify)"/g, (match, align) => {
      return `style="text-align:${align}"`;
    })
    .replace(/class="ql-header-(\d)"/g, (match, h) => {
      return `style="font-size:${2 - h * 0.25}em; font-weight:bold;"`;
    })
    // Add more replacements if you need for colors, backgrounds, etc.
}

const Editor = ({ placeholder, check, initialMessage, attachmentFiles, handleRemoveFile, formattedDate, initialReceiver, decryptedMessage, onclear }) => {
  const [editorHtml, setEditorHtml] = useState(localStorage.getItem("replyEmail") || "");
  const [isTyped, setIsTyped] = useState(false);
  const [editorMessage, setEditorMessage] = useState('');
  const [isSpellCheck, setIsSpellCheck] = useState('false');
  const [theme] = useState('snow');

  const html = check ? `<div>
  <p><br></p> 
  <p><br>---------------------------------------------------------------------</p>
  <p>On ${formattedDate}, ${initialReceiver} wrote:</p> 
  <blockquote>${decryptedMessage}</blockquote>
  <p></p>
  </div>` : ``;

  useEffect(() => {
    if (onclear) {
      setEditorHtml(html);
      setEditorMessage('');
    }
    if (!check) {
      localStorage.setItem("replyEmail", "");
      setIsTyped(true);
      setEditorHtml('');
      setEditorMessage('');
      singnature('');
    } else {
      setEditorMessage(html);
      singnature(html);
    }
  }, [check, html, onclear]);

  const singnature = async(html) => {
    const signatureData = await getSingnature();
    if(signatureData.signature){
      const decodedSignature = signatureData.isHtml ? decodeHtml(signatureData.signature) : signatureData.signature;
      setEditorMessage(html+`<div>
        <p><br></p> 
        <p><br></p>
        ${decodedSignature}
      </div>`);
    }
  }

  useEffect(() => {
    const getData = async () => {
      const generalSettings = await getGeneralSettings();
      setIsSpellCheck(generalSettings.isSpellChecked ? "true" : "false");
    }
    getData();
  }, []);

  useEffect(() => {
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      editor.focus();
      editor.setAttribute('spellcheck', isSpellCheck);
    }
  }, [editorHtml]);

  // When sending or saving, convert editorHtml to inline styles for Gmail compatibility
  const handleChange = (e) => {
    setTimeout(() => {
      setIsTyped(true);
    }, 1000);

    localStorage.setItem("replyEmail", e);
    setEditorHtml(e);
    setEditorMessage(e);
  }

  // Use this function to get inline style converted HTML when sending email
  const getCleanHtml = () => {
    return convertToInlineStyles(editorHtml);
  }

  return (
    <div className="quil-text-editor reply">
      <ReactQuill
        theme={theme}
        onChange={handleChange}
        value={editorHtml}
        modules={{ toolbar: editorConstant.toolBar}}
        placeholder={placeholder}
      />
    </div>
  );
};

Editor.propTypes = {
  placeholder: PropTypes.string,
  check: PropTypes.bool.isRequired,
  initialMessage: PropTypes.string,
  handleRemoveFile: PropTypes.func.isRequired,
  formattedDate: PropTypes.string.isRequired,
  initialReceiver: PropTypes.string.isRequired,
  decryptedMessage: PropTypes.string
};

export default Editor;
